import { c as _c } from "react/compiler-runtime";
import { IconSystemButton } from '#components/base/IconButton/IconSystemButton';
import { useIsJsEnabled } from '#cutils/hooks/use-is-js-enabled';
import styles from './MediaControlButton.module.scss';
export type MediaControlButtonVariant = 'audio' | 'video' | 'livestream';
type Props = {
  variant: MediaControlButtonVariant;
  onClick?: () => void;
  className?: string | undefined;
  title?: string;
};
export function MediaControlButton(t0) {
  const $ = _c(5);
  const {
    variant,
    onClick,
    className: t1,
    title
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isJavascriptEnabled = useIsJsEnabled();
  if (!isJavascriptEnabled) {
    return null;
  }
  let buttonTitle;
  bb0: switch (variant) {
    case "audio":
      {
        buttonTitle = "Audio abspielen";
        break bb0;
      }
    case "livestream":
      {
        buttonTitle = "Livestream abspielen";
        break bb0;
      }
    case "video":
      {
        buttonTitle = "Video abspielen";
      }
  }
  const t2 = `${styles.playButton} ${className}`;
  const t3 = title ? title : buttonTitle;
  const t4 = title ? title : buttonTitle;
  let t5;
  if ($[0] !== onClick || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = <IconSystemButton type="primary" icon="play" variant="filled" data-theme="dark" className={t2} aria-label={t3} title={t4} onClick={onClick} />;
    $[0] = onClick;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}